var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.container }, [
    _c(
      "div",
      { class: _vm.$style.header },
      [
        _c("NsMinimalHeaderProfileToggle", {
          attrs: {
            compact: "",
            "dropdown-open": _vm.dropdownOpen,
            greeting: _vm.profileTranslations.greeting,
            "sign-in-label": _vm.profileTranslations.signIn,
            "sign-up-label": _vm.profileTranslations.signUp
          },
          on: { toggle: _vm.handleDropdownToggle }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            class: _vm.$style.closeButton,
            on: { click: _vm.handleCloseClick }
          },
          [
            _c("NsIcon", {
              class: _vm.$style.closeIcon,
              attrs: {
                "icon-name": "icon-close-24",
                size: "custom",
                "data-testid": "profileDropdownMobileClose"
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }